import React from "react";
import { Avatar, Box } from "@mui/material";
import { keyframes } from "@emotion/react";

// 定义柔和金光的动画
const softGoldShine = keyframes`
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
`;

const GoldShiningAvatar = ({ src, width, height }: { src: string; width: string; height: string }) => {
  return (
    <Box
      sx={{
        position: "relative",
        width: width,
        height: height,
        borderRadius: "50%",
        overflow: "hidden",
      }}
    >
      {/* Avatar */}
      <Avatar
        src={src}
        sx={{
          width: "100%",
          height: "100%",
        }}
      />
      {/* 柔和金光层 */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "150%",
          height: "100%",
          background:
            "linear-gradient(90deg, rgba(255, 215, 0, 0) 20%, rgba(255, 215, 0, 0.3) 50%, rgba(255, 215, 0, 0) 80%)",
          animation: `${softGoldShine} 4s linear infinite`,
          filter: "blur(4px)", // 模糊边缘效果
          pointerEvents: "none",
          opacity: 0.6,
        }}
      />
    </Box>
  );
};

export default GoldShiningAvatar;
